import React from 'react';
import { GenericAlphaNumericInput } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { StandardLabel } from 'web-ui-components/lib/typography/labels';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isValidGlobalBehaviour } from '../../../utils/validation';

const required = value =>
  isValidGlobalBehaviour(value, 'alphanumericSpecial') ? undefined : 'Required';
const Username = ({ isExisting, username }) => {
  return (
    <Content>
      {({
        usernamePasswordUsernameLabel = '',
        usernamePasswordUsernameSupplement = '',
        usernamePasswordUsernameError = '',
        backButttonUsernameSupplement = ''
      }) => (
        <Field name="username" subscription={{ touched: true, error: true }}>
          {({ meta: { touched, error } }) => (
            <div>
              <GenericFieldWrapper
                inputId="username"
                title={usernamePasswordUsernameLabel}
                description={
                  isExisting ? backButttonUsernameSupplement : usernamePasswordUsernameSupplement
                }
                validationMessage={touched && !!error ? usernamePasswordUsernameError : ''}
              >
                {isExisting ? (
                  <StandardLabel>
                    <span>{username}</span>
                  </StandardLabel>
                ) : (
                  <Field name="username" component="input" validate={isExisting ? '' : required}>
                    {({ input }) => (
                      <GenericAlphaNumericInput
                        id="username"
                        {...input}
                        maxLength={70}
                        value={input.value}
                        onChange={event => input.onChange(event.value)}
                      />
                    )}
                  </Field>
                )}
              </GenericFieldWrapper>
            </div>
          )}
        </Field>
      )}
    </Content>
  );
};

export default Username;
